import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../http";
import { useSelector } from "react-redux";

function CeoMessage() {
  const [hospitalAbout, setHospitalAbout] = useState({});
  const [expanded, setExpanded] = useState(false);
  const truncateLength = 770;
  const siteData = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getHospitalAboutData();
  }, []);

  const getHospitalAboutData = async () => {
    try {
      const response = await SendPostRequest("content/aboutus");
      if (response?.data) {
        setHospitalAbout(response.data);
      }
    } catch (error) {
      console.error("Error fetching hospital about data:", error);
    }
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  const shouldTruncate =
    hospitalAbout?.ceo_description?.length > truncateLength;
  const displayContent = expanded
    ? hospitalAbout?.ceo_description
    : shouldTruncate
    ? truncateText(hospitalAbout?.ceo_description, truncateLength)
    : hospitalAbout?.ceo_description;

  function truncateText(text, maxLength) {
    if (!text) return "";
    return text.slice(0, maxLength) + "...";
  }

  return (
    <>
      {hospitalAbout?.ceo_description && hospitalAbout?.ceo_image && (
        <section id="section-about" className="section-about pb-0 pt-0">
          <div className="container">
            <div className="row d-flex align-items-center mb-4">
              <div className="col-lg-6 pe-lg-5" data-animation="fadeInLeft">
                <div className="about-wrap relative">
                  <div className="about-wrap-inner">
                    <div className="about-wrap-details">
                      <div className="text-center">
                        <div className="about-img">
                          <div
                            className="ceo-image"
                            style={{
                              backgroundImage: `url(${hospitalAbout.ceo_image})`,
                              backgroundSize: "cover",
                              backgroundPosition: "top center",
                              height: "520px",
                              width: "100%",
                              borderTopRightRadius: "60px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 py-5" data-animation="fadeInRight">
                <div className="title-wrap margin-bottom-20">
                  <div className="section-title">
                    <div className="section-title margin-bottom-40">
                      <h2 className="title text-uppercase mb-0">
                        {siteData?.site_type === "hospitals" ? (
                          <>
                            CEO <span className="theme-color">Message</span>
                          </>
                        ) : (
                          <>
                            DOCTOR <span className="theme-color">Message</span>
                          </>
                        )}
                      </h2>
                      <span className="section-border-bottom"></span>
                    </div>
                  </div>
                  <div className="pad-top-5">
                    <div>
                      <span
                        dangerouslySetInnerHTML={createMarkup(displayContent)}
                      />
                    </div>
                  </div>
                </div>
                {shouldTruncate && (
                  <button
                    onClick={() => setExpanded(!expanded)}
                    className="btn btn-default"
                  >
                    {expanded ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default CeoMessage;
